"use client";
import React, { useEffect, useState } from "react";
import { LiveDataType } from "../../../types/common.types";
import { GetLiveAstroData } from "../helper";
import styles from "./more-layout.module.scss";
import { AstrologerCard } from "../../../common/components/AstrologerCard";
import LiveSessionCard from "../../../common/components/LiveSessionCard";
import { useRouter } from "next/navigation";
import { handleCardClick } from "../RoomsExplore/components/PostsContainer/PostsContainer";
export default function MoreLayout() {
  const router = useRouter();
  const [sessions, setSessions] = useState<LiveDataType | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      const sessionData = await GetLiveAstroData();
      setSessions(sessionData);
    };
    fetchData();
  }, []);

  return (
    <div className={styles.more_layout_cont}>
      <p className={styles["current_section_heading"]}>Need more guidance?</p>
      <div className={styles["connect_with"]}>
        <p>Connect with an astrologer </p>
        <p onClick={() => router.push("/call")}>View all {">"} </p>
      </div>
      <div className={`${styles["cards_cont"]} ${styles["astrologer_cont"]}`}>
        {sessions?.astrologers.map((astrologerSession, index) => (
          <AstrologerCard
            session={astrologerSession}
            key={astrologerSession.liveRoom.userId}
            handleClick={() =>
              handleCardClick(astrologerSession.userProfile.userName, router)
            }
            index={index}
          />
        ))}
      </div>
      <p className={styles["current_section_heading"]}>Live Sessions</p>
      <div className={styles["connect_with"]}>
        <p>Connect with an astrologer </p>
        <p onClick={() => router.push("/live")}>View all {">"} </p>
      </div>
      <div className={`${styles["cards_cont"]} ${styles["live_session_cont"]}`}>
        {sessions?.liveSessions.map((astrologerSession) => (
          <LiveSessionCard
            session={astrologerSession}
            key={astrologerSession.liveRoom.userId}
          />
        ))}
      </div>
    </div>
  );
}
